import { useState } from 'react';
import { FiArrowUpRight, FiMenu, FiX } from 'react-icons/fi';
import Icon from './Icon';
import { NavItem } from '../types/portfolio';

type NavbarProps = {
  initials: string;
  navItems: NavItem[];
  linkedinUrl: string;
};

function Navbar({ initials, navItems, linkedinUrl }: NavbarProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="fixed inset-x-0 top-4 z-50 px-4 sm:px-6">
      <div className="mx-auto max-w-6xl rounded-full border border-white/10 bg-slate-950/70 px-4 py-3 shadow-glow backdrop-blur-xl">
        <div className="flex items-center justify-between gap-4">
          <a
            href="#home"
            className="flex items-center gap-3 rounded-full border border-white/10 bg-white/5 px-3 py-2 text-sm font-semibold text-slate-100 transition hover:border-sky-400/40 hover:bg-sky-400/10"
          >
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-gradient-to-br from-sky-400 to-teal-400 text-sm font-bold text-slate-950">
              {initials}
            </span>
            <span className="hidden sm:inline">Senior Engineer Portfolio</span>
          </a>

          <nav className="hidden items-center gap-6 lg:flex" aria-label="Primary">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="text-sm text-slate-300 transition hover:text-white"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href={linkedinUrl}
              target="_blank"
              rel="noreferrer"
              className="hidden rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm font-medium text-slate-100 transition hover:border-sky-400/40 hover:bg-sky-400/10 sm:inline-flex sm:items-center sm:gap-2"
            >
              LinkedIn
              <Icon icon={FiArrowUpRight} />
            </a>

            <button
              type="button"
              onClick={() => setIsOpen((current) => !current)}
              className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/10 bg-white/5 text-slate-100 lg:hidden"
              aria-label={isOpen ? 'Close navigation menu' : 'Open navigation menu'}
            >
              {isOpen ? <Icon icon={FiX} /> : <Icon icon={FiMenu} />}
            </button>
          </div>
        </div>

        {isOpen ? (
          <nav className="mt-4 grid gap-3 border-t border-white/10 pt-4 lg:hidden" aria-label="Mobile">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setIsOpen(false)}
                className="rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-slate-200 transition hover:border-sky-400/30 hover:bg-sky-400/10"
              >
                {item.label}
              </a>
            ))}
          </nav>
        ) : null}
      </div>
    </header>
  );
}

export default Navbar;
